import { CheckCircle, XCircle } from "@phosphor-icons/react";
import { isB1 } from "../lib/cefr";

export default function B1Verdict({ score, size = "md", testId }) {
  const ok = isB1(score);
  const sizeCls = size === "sm" ? "text-xs px-2 py-0.5 gap-1" : "text-sm px-3 py-1.5 gap-2";
  const tone = ok ? "border-emerald-600 text-emerald-700 dark:text-emerald-400 bg-emerald-600/10" : "border-foreground/40 text-foreground/80";
  const Icon = ok ? CheckCircle : XCircle;
  return (
    <span data-testid={testId} data-verdict={ok ? "b1" : "not-b1"} className={`inline-flex items-center font-bold border whitespace-nowrap ${tone} ${sizeCls}`}>
      <Icon size={size === "sm" ? 12 : 16} weight="fill" />
      {ok ? "B1 reached" : "Not yet B1"}
    </span>
  );
}
